import React, { useState } from 'react'
import { deepFind } from 'react-children-utilities'
import { usePopper } from 'react-popper'

const Trigger = () => null
const Content = () => null

const Popover = ({ children, visible, options, placement = 'bottom-start' }) => {

	const trigger = deepFind(children, child => child.type === Trigger)
	const content = deepFind(children, child => child.type === Content)

	const [referenceElement, setReferenceElement] = useState(null)
	const [popperElement, setPopperElement] = useState(null)
	const { styles, attributes } = usePopper(referenceElement, popperElement, { placement: placement, ...options })

	return (
		<>
			<div style={trigger?.props?.style ?? { display: 'inline-block' }} ref={setReferenceElement}>
				{ trigger && trigger.props.children }
			</div>

			{ visible &&
				<div ref={setPopperElement} style={{...styles.popper, zIndex: 1}} {...attributes.popper}>
					{ content && content.props.children }
				</div>
			}
		</>
	)
}

Popover.Trigger = Trigger
Popover.Content = Content

export default Popover
